module.exports = "<user-permission-role-list id=\"user-permission-role-list\" (openUserRole)=\"handleOpenUserRole($event)\"\n(addUsersToRole)=\"handleAddUsersToRole($event)\" class=\"col-md-10\"></user-permission-role-list>"


//////////////////
// WEBPACK FOOTER
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/global-settings/permission-settings/user-permission-role-list.component.html
// module id = ../../../../../src/app/global-settings/permission-settings/user-permission-role-list.component.html
// module chunks = 2